import { Component, computed, inject } from '@angular/core';
import { MyForestMainInfoComponent } from './my-forest-main-info/my-forest-main-info.component';
import { AuthService } from 'core/services/auth.service';
import { MyForestMainInfoSpecialComponent } from './my-forest-main-info-special/my-forest-main-info-special.component';

@Component({
  selector: 'app-dashboard',
  imports: [MyForestMainInfoComponent, MyForestMainInfoSpecialComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  #authService = inject(AuthService);

  userIsSpecial = computed<boolean>(() => !!this.#authService?.currentUser?.isSpecial);
}
